import { render, staticRenderFns } from "./ScrollTo.vue?vue&type=template&id=482f303f&scoped=true"
import script from "./ScrollTo.vue?vue&type=script&lang=js"
export * from "./ScrollTo.vue?vue&type=script&lang=js"
import style0 from "./ScrollTo.vue?vue&type=style&index=0&id=482f303f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f303f",
  null
  
)

export default component.exports